/**
 * main.tsx - Application entry point
 * SwapyBook PWA - Book Exchange Platform
 */
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Get root element
const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Failed to find the root element");
}

// Create React root and render application
createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
